class SearchInput extends HTMLElement {

  constructor () {
    super()
    this.elements = {
      input: this.querySelector('[data-search-input-el="input"]'),
      closeDropdown: this.querySelector('[data-search-input-el="close-dropdown"]'),
      submit: this.querySelector('[data-search-input-el="submit"]'),
      ariaLiveHappy: this.querySelector('[data-search-input-el="aria-live-happy"]'),
      ariaLiveSad: this.querySelector('[data-search-input-el="aria-live-sad"]'),
    }

    this.externalElements = {
      dropdown: document.querySelector('[data-search-input-external-el="dropdown"]'),
      container: document.querySelector('[data-search-input-external-el="container"]'),
    }

    // Add timeout ID for debouncing accessibility announcements
    this.a11yAnnouncementTimeout = null
    // Track last announced state to prevent duplicate announcements
    this.lastAnnouncedState = {
      term: null,
      totalResults: null
    }
  }
  connectedCallback () {
    this.attachEventListeners()
  }

  attachEventListeners () {
    if(this.elements.input) {
      this.elements.input.addEventListener('input', this.handleInput.bind(this))

      this.elements.input.addEventListener('focus', this.handleDropdownOpen.bind(this))
    }

    if(this.elements.closeDropdown) {
      this.elements.closeDropdown.addEventListener('click', this.handleDropdownClose.bind(this))
    }

    window.addEventListener('mobile-nav-drawer:ui:open', this.handleDropdownClose.bind(this))

    this.addEventListener('submit', this.handleFormSubmit.bind(this))

    window.theme.searchAutocomplete.eventBus.subscribe('searchAutoComplete:state:updated',  (results) => this.handleA11yTermUpdated(results))
  }

  handleInput () {
    const searchTerm = this.elements.input.value.trim()

    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:term:updated', {
      term: searchTerm
    })

    this.elements.input.focus()
  }

  handleA11yTermUpdated(results) {
    // Clear any existing timeout to prevent multiple announcements
    if (this.a11yAnnouncementTimeout) {
      clearTimeout(this.a11yAnnouncementTimeout)
    }

    // Check if we've already announced this exact state to prevent duplicates
    const currentState = {
      term: results.term,
      totalResults: results.products.hits.length
    }

    if (this.lastAnnouncedState.term === currentState.term &&
        this.lastAnnouncedState.totalResults === currentState.totalResults) {
      return // Skip announcement if it's the same as the last one
    }

    // Delay the announcement to allow VoiceOver to finish reading current content
    this.a11yAnnouncementTimeout = setTimeout(() => {
      if(results.products.hits.length > 0) {
        this.elements.ariaLiveHappy.textContent = `${results.products.hits.length} results found for '${results.term}'`
        this.elements.ariaLiveSad.textContent = ''
      } else {
        this.elements.ariaLiveSad.textContent = `No search results for '${results.term}'`
        this.elements.ariaLiveHappy.textContent = ''
      }

      // Update the last announced state
      this.lastAnnouncedState = currentState
    }, 800) // 800ms delay to allow VoiceOver to finish current announcement
  }

  handleFormSubmit(event) {
    event.preventDefault();
    const searchTerm = this.elements.input.value.trim();

    // Redirect to the search results page with the search term as a query parameter
    if (searchTerm) {
      window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
    }

    window.dataLayer.push({
      event: 'search',
      search_term: searchTerm,
    })
  }

  handleDropdownOpen () {
    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:dropdown:open')

    if( this.elements.closeDropdown) {
      this.elements.closeDropdown.classList.remove('hidden')
    }

    if( this.elements.submit) {
      this.elements.submit.classList.add('hidden')
    }

    this.elements.input.focus();

    document.body.style.overflow = 'hidden';

    this.publishEventToCloseMobileNavDrawer()

  }

  handleDropdownClose () {
    window.theme.searchAutocomplete.eventBus.publish('searchAutoComplete:ui:dropdown:close')

    if(this.elements.closeDropdown) {
      this.elements.closeDropdown.classList.add('hidden')
    }

    if(this.elements.submit) {
      this.elements.submit.classList.remove('hidden')
    }

    this.elements.input.blur();

    document.body.style.overflow = 'visible';
  }

  publishEventToCloseMobileNavDrawer () {
    const customEvent = new CustomEvent('mobile-nav-drawer:ui:close');
    window.dispatchEvent(customEvent);
  }

}

customElements.define('search-input', SearchInput)
